import React, { useState } from "react";
import FinalExamUnlocker from "./FinalExamUnlocker";
import { HandleFinalExamLockingAndUnlocking } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Col, Card, CardTitle, Collapse, CardBody } from "reactstrap";
import { FormattedMessage } from "react-intl";
import TooltipHelp from "../Help/ToolTipHelp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function FinalExamUnlockerContainer(props) {
  const [showCoursesForUnlocking, setShowCoursesForUnlocking] = useState(false);
  const [collapsed, setCollapsed] = useState([]);
  const [isFetchingFinalExam, setIsFetchingFinalExam] = useState(false);

  const mutateFinalExamToggler = useMutation({
    mutationFn: HandleFinalExamLockingAndUnlocking
  });
  const queryClient = useQueryClient();

  const finish = (done) => {
    setIsFetchingFinalExam(false);
    done && done();
  };

  const handleStudentLockUnlockFinalExam = (event, course, done) => {
    setIsFetchingFinalExam(true);

    let postData = [];
    let studentCourses = props.studentCoursesWithStudentModule.data.filter(
      (x) => x.id === course.id
    );
    studentCourses[0].students.forEach((student) => {
      postData.push({
        Id: student.studentCourse.id,
        FinalExamEnabled: event.target.checked,
      });
    });

    const values = postData.map((module) => ({
      Id: module.Id,
      FinalExamEnabled: module.FinalExamEnabled,
    }));

    mutateFinalExamToggler.mutate(
      {
        values,
      },
      {
        onSuccess: (data) => {
          if (data && data.status > 199 && data.status < 300) {
            queryClient
              .invalidateQueries({ queryKey: [
                "FetchCoursesByStudentEmail",
                props.studentEmail,
              ] })
              .then(() => finish(done));
          } else {
            toast.warn(data);
            finish(done);
          }
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
          finish(done);
        },
      }
    );
  };

  const handleClassLockUnlockFinalExam = (event, course, done) => {
    setIsFetchingFinalExam(true);

    let values = [];
    course.students.forEach((student) => {
      values.push({
        Id: student.studentCourse.id,
        FinalExamEnabled: event.target.checked,
      });
    });
    mutateFinalExamToggler.mutate(
      {
        values,
      },
      {
        onSuccess: (data) => {
          if (data && data.status > 199 && data.status < 300) {
            queryClient
              .invalidateQueries({ queryKey: ["FetchCoursesByClassId"] })
              .then(() => finish(done));
          } else {
            toast.warn(data);
            finish(done);
          }
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
          finish(done);
        },
      }
    );
  };

  const studentcoursesWithFinalExam = () => {
    if (props.courses) {
      let data = props.courses.filter((course) => {
        let courseWithFinalExam =
          props.studentCoursesWithStudentModule.data.some(
            (c) => c.id === course.id && c.hasFinalExam
          );
        return courseWithFinalExam;
      });
      return data;
    }
    return null;
  };

  const classCoursesWithFinalExam = () => {
    let data = [];
    let courses = props.courses.filter((course) => course.hasFinalExam);
    courses.forEach((c) => {
      let finalExamEnabled = false;
      c.students.forEach((stud) => {
        if (stud.studentCourse.finalExamEnabled) {
          finalExamEnabled = true;
        }
      });
      let courseToAdd = {
        imgUrl: c.imgUrl,
        finalExamEnabled: finalExamEnabled,
        name: c.courseName,
        id: c.id,
        hasGy25ModuleWithQApiId: c.hasGy25ModuleWithQApiId,
        hasGy25FinalExam: c.hasGy25FinalExam,
        students: c.students,
        modules: c.modules,
      };
      data.push(courseToAdd);
    });
    return data;
  };

  const getStudentCoursesWithModules = () => {
    if (props.studentCoursesWithStudentModule) {
      let data = props.studentCoursesWithStudentModule.data.filter(
        (c) => c.hasFinalExam
      );
      return data;
    }
    return null;
  };

  return (
    <Col lg={12}>
      <Card>
        <CardBody>
          <CardTitle
            onClick={() => setCollapsed(!collapsed)}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon
              style={{ marginRight: ".5em" }}
              className={
                collapsed
                  ? "fa-caret--animated"
                  : "fa-caret--animated collapsed"
              }
              icon={"caret-up"}
            />
            <FormattedMessage id="FinalExam" />
            <TooltipHelp
              id="FinalExam"
              toolTipText={<FormattedMessage id="ToolTipFinalExam" />}
              placement="right"
            />
            <hr />
          </CardTitle>
          <Collapse isOpen={!collapsed} style={{ margin: "0 10px 0 10px" }}>
            {props.studentHasNoLicense ? (
              <div>
                <FormattedMessage
                  values={{ studentName: props.studentName }}
                  id="StudentHasNoLicense"
                />
              </div>
            ) : (
              <FinalExamUnlocker
                searchList={props.searchList}
                placeHolder={props.placeHolder}
                setShowCoursesForUnlocking={setShowCoursesForUnlocking}
                showCoursesForUnlocking={showCoursesForUnlocking}
                toggleCoursesDropdown={props.toggleCoursesDropdown}
                showCourses={props.showCourses}
                courses={
                  props.level === "Student"
                    ? studentcoursesWithFinalExam()
                    : classCoursesWithFinalExam()
                }
                studentCoursesModules={
                  props.level === "Student"
                    ? getStudentCoursesWithModules()
                    : []
                }
                handleLockUnlockFinalExam={
                  props.level === "Student"
                    ? handleStudentLockUnlockFinalExam
                    : handleClassLockUnlockFinalExam
                }
                programId={props.programId}
                classId={props.classId}
                student={props.level === "Student" ? [props.student] : []}
                level={props.level}
                isFetchingFinalExam={isFetchingFinalExam}
              />
            )}
          </Collapse>
        </CardBody>
      </Card>
    </Col>
  );
}
